import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IPaginationRecordset, IPageChange } from './IPagination';

@Component({
    selector: 'pagination',
    template: `
        <ng-container *ngIf="listLength > 0">
            <p-paginator [rows]="listLength"
                         [totalRecords]="recordset.total"
                         [first]="recordset.first"
                         [rowsPerPageOptions]="pageSizeOptions"
                         (onPageChange)="onPageChangeEvent($event)">
            </p-paginator>
        </ng-container>
    `,
    styleUrls: ['./pagination.scss']
})

export class PaginationComponent {

    @Input()
    public listLength: number;

    @Input()
    public recordset: IPaginationRecordset;

    @Input()
    public pageSizeOptions: number[] = [10, 20, 50, 100];

    @Output()
    public readonly onPageChange: EventEmitter<IPageChange> = new EventEmitter();

    public onPageChangeEvent(event: IPageChange): void {
        this.onPageChange.emit(event);
    }
}
